/**
 * 安全運転管理ページ用のスクリプト
 */
 if (is_route('safety_drive.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        safety_drive_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.safety_drive_event_set = function() {

    /*---- 検索 ----*/
    
    // 検索ボタン押下時
    $(document).on('click', '#search-form-action_search', function () {
        // コンテンツを読込
        load_contents(null, false);
    });

    /*---- 解析 ----*/

    // 解析確認時
    $(document).on('click', '[data-analyze_confirm-modal]', function () {
        _modal.create(this, 'analyze_confirm-modal', ['id']);
    });

    // 解析実行時
    $(document).on('click', '[data-analyze-modal]', function (e) {
        var modalId = create_id($(this).data('analyze-modal'));
        var formId = modalId + '-form';
        // 送信前にエラーをリセット
        _error.reset()
        $('#analysis-error-message').html("");
        // post送信
        _ajax.submit(formId, function (results) {
            if (results.result_code == 0 || results.result_code == 1) {
                // メッセージ表示
                toastr.success(results.messages);
                // モーダルを閉じる
                _modal.hide(modalId);
                // コンテンツ再読み込み
                load_contents();
            } else {
                $('#analysis-error-message').html(results.messages);
            }
        }, function(xhr, status, errorThrown){
            _error.set(xhr, status, errorThrown);
        });
    });
    
}
